/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContentItem = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M11 11h7v2h-7zm0 5h7v2h-7zm0-10h7v2h-7zM6 16h3v2H6z" />
      <path d="M2 2v20h20V2zm18 18H4V4h16z" />
      <path d="M6 6h3v2H6zm0 5h3v2H6z" />
    </g>
  </Icon>
);
export { SvgContentItem as ContentItem };
